import {Typography} from '@pixel-party/Typography/v2';
import {Trans} from 'react-i18next';
import {PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL} from '../../constants';

export function Consent() {
  return (
    <Typography
      use="caption"
      className="helpText"
    >
      <Trans
        i18nKey="forms.shared.consent"
        components={{
          policy: (
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          ),
          terms: (
            <a
              href={TERMS_OF_SERVICE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>
          ),
        }}
      />
    </Typography>
  );
}
